/**
 * @Title 常量
 * @author Alinc
 * @time 2019-10-9 11:27:04
 */
import { lang } from '@/utils/filters'

const { VUE_APP_API_URL } = process.env
export const I18N_URL = process.env.VUE_APP_in18_URL
// 环境变量
export const ENV = process.env.NODE_ENV

export const Appkey = '189929962'

// 是否为正式环境
export const IS_PROD = ENV === 'production'

// 基本请求路径
export const BASE_URL = IS_PROD ? VUE_APP_API_URL : '/api'

// excel上传路径
export const EXCEL_URL = VUE_APP_API_URL + '/vip/order/excelImport'

// excel 上传地址路径
export const EXCEL_URL_3 = VUE_APP_API_URL + '/vip/address/importData'

// excel上传路径,省、市、区、详细地址未拆分，需要系统智能拆分
export const EXCEL_URL_2 = VUE_APP_API_URL + '/vip/order/excelImportMatchAddress'

// 新批量打入模板 20201209新增
export const EXCEL_IMPORT = VUE_APP_API_URL + '/vip/excel/excelImport'

// 国际件导入
export const INTER_EXCEL_IMPORT = VUE_APP_API_URL + '/vip/excel/international/excelImport'

// 图上传路径-暂无
export const IMG_URL = VUE_APP_API_URL + ''

// 请求成功
export const RESPONSE_SUCCESS = 1

// token过期
export const RESPONSE_EXPIRED = '000002'

// 请求中断标识
export const INTERRUPT = 'INTERRUPT'
// 静态字典
export const DIC = {
  payTypes: [{ code: 'PP_PM', name: '寄付月结', id: 319, type: 'ZD106' }, { code: 'PP_CASH', name: '寄付现结', id: 320, type: 'ZD106' }, { code: 'CC_CASH', name: '到付现结', id: 321, type: 'ZD106' }],
  specTypes: [{ name: '物品类型2', code: 'B0002' }, { name: '物品A', code: 'article21' }, { name: '包装箱', code: '12457' }],
  insured: [{ code: 0, label: '否', name: '否' }, { code: 1, label: '是', name: '是' }],
  signReceipt: [{ code: 0, label: '否', name: '否' }, { code: 1, label: '是', name: '是' }],
}

export const exportModuleNameMap = {
  'my_order_qy': lang('我的订单-网页下单'),
  'my_waybill_qy': lang('我的运单'),
  'web_order': lang('三方订单'),
  'vip_problem_list': lang('问题件日历'),
  'vip_problem_desc': lang('问题件明细'),
  'reback_express_qy': lang('退回件'),
  'problem_handling': lang('问题件处理'),
  'my_order_inter': lang('国际件'),
  'in_detail_harbor': lang('进港详情'),
  'in_harbor': lang('进港列表'),
  'out_detail_harbor': lang('出港详情'),
  'out_harbor': lang('出港列表'),
  'vip_problem_handle': lang('问题件处理'),
}
// 后端语种与element国际化的对应map
export const LANG_ELEMENT_MAP = {
  'CN': 'zh-cn', // 中文
  'EN': 'en', // 英语
  'TH': 'th', // 泰语
  'KH': 'kh', // 柬埔寨(暂无)
  'MY': 'my', // 马来语(暂无)
  'ID': 'id', // 印尼语
  'VN': 'vi', // 越南语
  'AR': 'ar', // 阿拉伯语

}
// 静态菜单
export const MENU = [
  {
    'routeName': 'orders',
    'id': 537,
    'menuIcon': 'iconwoyaojijian',
    'name': '我要寄件',
    'parentId': 527,
    'moduleType': 2,
    'isShow': 1,
    'children': [
      {
        'isShow': 1,
        'routeName': 'singleOrder',
        'id': 813,
        'menuIcon': '',
        'name': '单票下单',
        'parentId': 538,
        'moduleType': 3,
      },
      {
        'isShow': 1,
        'routeName': 'batchOrder',
        'children': null,
        'id': 809,
        'menuIcon': '',
        'name': '批量下单',
        'parentId': 539,
        'moduleType': 3,
      },
      {
        'isShow': 1,
        'routeName': 'externalOrdersNo',
        'children': null,
        'id': 810,
        'menuIcon': '',
        'name': '三方下单',
        'parentId': 540,
        'moduleType': 3,
      }
    ],
  },
  {
    'routeName': 'international',
    'id': 550,
    'menuIcon': 'iconwoyaojijian',
    'name': '国际件',
    'parentId': 527,
    'moduleType': 2,
    'isShow': 1,
    'children': [
      {
        'isShow': 1,
        'routeName': 'batchEntry',
        'id': 863,
        'menuIcon': '',
        'name': '进口国际件',
        'parentId': 550,
        'moduleType': 3,
      },
      {
        'isShow': 1,
        'routeName': 'orderList',
        'children': null,
        'id': 889,
        'menuIcon': '',
        'name': '订单列表',
        'parentId': 550,
        'moduleType': 3,
      },
      {
        'isShow': 1,
        'routeName': 'batchOrderNew',
        'id': 890,
        'menuIcon': '',
        'name': '出口国际件',
        'parentId': 550,
        'moduleType': 3,
      },
    ],
  },
  {
    'routeName': 'orderList',
    'id': 540,
    'menuIcon': 'iconwodedingdan',
    'name': '我的订单',
    'parentId': 527,
    'moduleType': 2,
    'isShow': 1,
    'children': [
      {
        'isShow': 1,
        'routeName': 'order',
        'id': 813,
        'menuIcon': '',
        'name': '网页下单',
        'parentId': 540,
        'moduleType': 3,
      },
      {
        'isShow': 1,
        'routeName': 'externalOrders',
        'children': null,
        'id': 811,
        'menuIcon': '',
        'name': '三方订单',
        'parentId': 540,
        'moduleType': 3,
      },
    ],
  },
  {
    'routeName': 'waybill',
    'id': 541,
    'menuIcon': 'iconwodeyundan',
    'name': '我的运单',
    'parentId': 527,
    'moduleType': 3,
    'isShow': 1,
  },
  {
    'routeName': 'problemShipment',
    'id': 553,
    'menuIcon': 'iconfuwuguanli',
    'name': '问题件',
    'parentId': 537,
    'moduleType': 2,
    'isShow': 1,
    'children': [
      {
        'isShow': 1,
        'routeName': 'problemCalendar',
        'children': null,
        'id': 813,
        'menuIcon': '',
        'name': '问题件日历',
        'parentId': 537,
        'moduleType': 3,
      },
      {
        'isShow': 1,
        'routeName': 'problemDetail',
        'children': null,
        'id': 819,
        'menuIcon': '',
        'name': '问题件明细',
        'parentId': 537,
        'moduleType': 3,
      },
      {
        'isShow': 1,
        'routeName': 'returnParcel',
        'children': null,
        'id': 820,
        'menuIcon': '',
        'name': '退回件',
        'parentId': 537,
        'moduleType': 3,
      },
      {
        'isShow': 1,
        'routeName': 'problemHandling',
        'children': null,
        'id': 821,
        'menuIcon': '',
        'name': '问题件处理',
        'parentId': 537,
        'moduleType': 3,
      },
    ],
  },
  {
    'parentId': 1,
    'id': 554,
    'routeName': 'returns',
    'menuIcon': 'iconfuwuguanli',
    'name': '退换货',
    'moduleType': 2,
    'isShow': 1,
    'children': [
      {
        'parentId': 1,
        'id': 123,
        'menuIcon': '',
        'routeName': 'ExchangeList',
        'name': '换货列表',
        'moduleType': 3,
        'isShow': 1,
        'children': null,
      },
      {
        'parentId': 1,
        'id': 124,
        'routeName': 'ReturnsList',
        'menuIcon': '',
        'name': '退货列表',
        'moduleType': 3,
        'isShow': 1,
        'children': null,
      },
    ],
  },
  {
    'routeName': 'outScope',
    'id': 547,
    'menuIcon': 'iconfuwuguanli',
    'name': '签收时效',
    'parentId': 563,
    'moduleType': 2,
    'isShow': 1,
    'children': [
      {
        'isShow': 1,
        'routeName': 'outPort',
        'children': null,
        'id': 855,
        'menuIcon': '',
        'name': '出港维度',
        'parentId': 547,
        'moduleType': 3,
      },
      {
        'isShow': 1,
        'routeName': 'enterPort',
        'children': null,
        'id': 856,
        'menuIcon': '',
        'name': '进港维度',
        'parentId': 547,
        'moduleType': 3,
      },
    ],
  },
  {
    'routeName': 'workBench',
    'id': 542,
    'menuIcon': 'iconfuwuguanli',
    'name': '服务管理',
    'parentId': 527,
    'moduleType': 2,
    'isShow': 1,
    'children': [
      {
        'isShow': 1,
        'routeName': 'expressTracking',
        'children': null,
        'id': 813,
        'menuIcon': '',
        'name': '快件跟踪',
        'parentId': 542,
        'moduleType': 3,
      },
      {
        'isShow': 1,
        'routeName': 'freightInquiry',
        'children': null,
        'id': 809,
        'menuIcon': '',
        'name': '运费查询',
        'parentId': 542,
        'moduleType': 3,
      },
    ],
  },
  {
    'routeName': 'addressManage',
    'id': 545,
    'menuIcon': 'icondizhiguanli',
    'name': '地址管理',
    'parentId': 527,
    'moduleType': 2,
    'isShow': 1,
    'children': [
      {
        'isShow': 1,
        'routeName': 'mailingAddress',
        'children': null,
        'id': 823,
        'menuIcon': '',
        'name': '寄件地址',
        'parentId': 545,
        'moduleType': 3,
      },
      {
        'isShow': 1,
        'routeName': 'receivingAddress',
        'children': null,
        'id': 829,
        'menuIcon': '',
        'name': '收件地址',
        'parentId': 545,
        'moduleType': 3,
      },
      {
        'isShow': 1,
        'routeName': 'returnAddress',
        'children': null,
        'id': 830,
        'menuIcon': '',
        'name': '退回地址',
        'parentId': 545,
        'moduleType': 3,
      },
    ],
  },
  {
    'routeName': 'userManage',
    'id': 57,
    'menuIcon': 'iconyonghuguanli',
    'name': '用户管理',
    'parentId': 546,
    'moduleType': 3,
    'isShow': 1,
  },
]

// 运单导出字段
export const cityOptions = [
  {
    key: 'waybillNo',
    name: '运单编号',
    required: true,
    disabled: true,
  },
  {
    key: 'waybillStatusName',
    name: '状态',
    required: true,
    disabled: true,
  },
  {
    key: 'orderSourceName',
    name: '下单渠道',
    required: true,
    disabled: true,
  },
  {
    key: 'customerOrderId',
    name: '客户订单号',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverName',
    name: '收件人姓名',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverProvinceName',
    name: '收件省份',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverCityName',
    name: '收件城市',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverStreet',
    name: '收件街道',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverDetailedAddress',
    name: '收件详细地址',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverMobilePhone',
    name: '收件人手机号',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverTelphone',
    name: '收件人备用手机号码',
    required: true,
    disabled: true,
  },
  {
    key: 'senderName',
    name: '寄件人姓名',
  },
  {
    key: 'senderProvinceName',
    name: '省份',
  },
  {
    key: 'senderCityName',
    name: '寄件城市',
  },
  {
    key: 'senderStreet',
    name: '寄件街道',
  },
  {
    key: 'senderDetailedAddress',
    name: '寄件详细地址',
  },
  {
    key: 'senderMobilePhone',
    name: '寄件人手机号',
  },
  {
    key: 'goodsTypeName',
    name: '物品类型',
  },
  {
    key: 'goodsName',
    name: '物品名称',
  },
  {
    key: 'packageTotalWeight',
    name: '物品重量',
  },
  {
    key: 'packageNumber',
    name: '件数',
  },
  {
    key: 'subNo',
    name: '子单号',
  },
  //   {
  //     key: 'boxStandardName',
  //     name: '箱材规格',
  //   },
  //   {
  //     key: 'boxNumber',
  //     name: '箱材数量',
  //   },
  {
    key: 'insuredAmount',
    name: '物品价值',
  },
  // {
  //   key: 'packageNumber',
  //   name: '件数',
  // },
  {
    key: 'insuredFee',
    name: '赔偿上限服务费',
  },
  {
    key: 'boxPrice',
    name: '箱材价格',
  },
  {
    key: 'settlementName',
    name: '结算方式',
  },
  {
    key: 'paidModeName',
    name: '支付方式',
  },
  {
    key: 'platformName',
    name: '平台',
  },
  {
    key: 'customerAccount',
    name: '客户账号',
  },
  {
    key: 'codFee',
    name: '代收货款手续费',
  },
  {
    key: 'codMoney',
    name: 'COD收款金额',
  },

  // {
  //   key: 'codMoney',
  //   name: 'COD',
  // },
  // {
  //   key: 'codFee',
  //   name: 'COD手续费',
  // },
  {
    key: 'totalFreight',
    name: '参考运费',
  },
  // {
  //   key: 'orderSourceName',
  //   name: '下单渠道',
  // },
  {
    key: 'numberOfDispatch',
    name: '派件天次',
  },
  {
    key: 'exceptionReason',
    name: '异常件原因',
  },
  {
    key: 'abnormalDesc',
    name: '异常件描述',
  },
  {
    key: 'remarks',
    name: lang('备注'),
  },
  {
    key: 'orderAccount',
    name: '下单账号',
  },
  {
    key: 'expressTypeName',
    name: '产品类型名称',
  },
]

// 订单导出字段
export const orderOptions = [
  {
    key: 'id',
    name: '订单编号',
    required: true,
    disabled: true,
  },
  {
    key: 'waybillId',
    name: '运单编号',
    required: true,
    disabled: true,
  },
  {
    key: 'orderStatusName',
    name: '状态',
    required: true,
    disabled: true,
  },
  {
    key: 'customerOrderId',
    name: '客户订单号',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverName',
    name: '收件人姓名',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverMobilePhone',
    name: '收件人手机号',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverTelphone',
    name: '收件人备用手机号码',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverProvinceName',
    name: '收件省份',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverCityName',
    name: '收件城市',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverStreet',
    name: '收件街道',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverDetailedAddress',
    name: '收件详细地址',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverCompany',
    name: '收件人公司',
  },
  {
    key: 'senderName',
    name: '寄件人姓名',
  },
  {
    key: 'senderMobilePhone',
    name: '寄件人联系手机',
  },
  {
    key: 'senderProvinceName',
    name: '省份',
  },
  {
    key: 'senderCityName',
    name: '寄件城市',
  },
  {
    key: 'senderStreet',
    name: '寄件街道',
  },
  {
    key: 'senderDetailedAddress',
    name: '寄件详细地址',
  },
  {
    key: 'packageNumber',
    name: '件数',
  },
  {
    key: 'goodsTypeName',
    name: '物品类型',
  },
  {
    key: 'goodsName',
    name: '物品名称',
  },
  {
    key: 'packageTotalWeight',
    name: '物品重量',
  },
  {
    key: 'printsNumber',
    name: '打印次数',
  },
  {
    key: 'declaredValue',
    name: '物品价值',
  },
  // {
  //   key: 'packageNumber',
  //   name: '件数',
  // },
  {
    key: 'insuredValue',
    name: '赔偿上限服务费',
  },
  {
    key: 'paymentModeName',
    name: '结算方式',
  },
  {
    key: 'paidModeName',
    name: '支付方式',
  },
  {
    key: 'platformName',
    name: '平台',
  },
  {
    key: 'customerAccount',
    name: '客户账号',
  },
  {
    key: 'codMoney',
    name: 'COD收款金额',
  },
  {
    key: 'codFee',
    name: '代收货款手续费',
  },
  {
    key: 'standardValue',
    name: '参考运费',
  },
  {
    key: 'orderSourceName',
    name: '订单来源',
  },
  {
    key: 'remarks',
    name: '备注',
  },
  {
    key: 'needDispatch',
    name: '是否调度',
  },
  {
    key: 'orderAccount',
    name: '下单账号',
  },
  {
    key: 'expressTypeName',
    name: '产品类型名称',
  },
]

export const orderOptionsSecond = [
  {
    key: 'id',
    name: '订单编号',
    required: true,
    disabled: true,
  },
  {
    key: 'waybillId',
    name: '运单编号',
    required: true,
    disabled: true,
  },
  {
    key: 'orderStatusName',
    name: '状态',
    required: true,
    disabled: true,
  },
  {
    key: 'customerOrderId',
    name: '客户订单号',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverName',
    name: '收件人姓名',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverMobilePhone',
    name: '收件人手机号',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverTelphone',
    name: '收件人备用手机号码',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverProvinceName',
    name: '收件省份',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverCityName',
    name: '收件城市',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverStreet',
    name: '收件街道',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverDetailedAddress',
    name: '收件详细地址',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverShortAddress',
    name: '收件短地址',
  },
  {
    key: 'receiverReferenceNumber',
    name: '收件辅助编号',
  },
  {
    key: 'receiverBuildingNumber',
    name: '收件建筑物编号',
  },
  {
    key: 'receiverCompany',
    name: '收件人公司',
  },
  {
    key: 'senderName',
    name: '寄件人姓名',
  },
  {
    key: 'senderMobilePhone',
    name: '寄件人联系手机',
  },
  {
    key: 'senderProvinceName',
    name: '省份',
  },
  {
    key: 'senderCityName',
    name: '寄件城市',
  },
  {
    key: 'senderStreet',
    name: '寄件街道',
  },
  {
    key: 'senderDetailedAddress',
    name: '寄件详细地址',
  },
  {
    key: 'senderShortAddress',
    name: '寄件短地址',
  },
  {
    key: 'senderReferenceNumber',
    name: '寄件辅助编号',
  },
  {
    key: 'senderBuildingNumber',
    name: '寄件建筑物编号',
  },
  {
    key: 'packageNumber',
    name: '件数',
  },
  {
    key: 'goodsTypeName',
    name: '物品类型',
  },
  {
    key: 'goodsName',
    name: '物品名称',
  },
  {
    key: 'packageTotalWeight',
    name: '物品重量',
  },
  {
    key: 'printsNumber',
    name: '打印次数',
  },
  {
    key: 'declaredValue',
    name: '物品价值',
  },
  // {
  //   key: 'packageNumber',
  //   name: '件数',
  // },
  {
    key: 'insuredValue',
    name: '赔偿上限服务费',
  },
  {
    key: 'paymentModeName',
    name: '结算方式',
  },
  {
    key: 'paidModeName',
    name: '支付方式',
  },
  {
    key: 'platformName',
    name: '平台',
  },
  {
    key: 'customerAccount',
    name: '客户账号',
  },
  {
    key: 'codMoney',
    name: 'COD收款金额',
  },
  {
    key: 'codFee',
    name: '代收货款手续费',
  },
  {
    key: 'standardValue',
    name: '参考运费',
  },
  {
    key: 'orderSourceName',
    name: '订单来源',
  },
  {
    key: 'remarks',
    name: '备注',
  },
  {
    key: 'needDispatch',
    name: '是否调度',
  },
  {
    key: 'orderAccount',
    name: '下单账号',
  },
  {
    key: 'expressTypeName',
    name: '产品类型名称',
  },
]

// 签收时效详情字段
export const portDelOptions = [
  {
    key: 'deliverTime',
    name: lang('派件时间'),
    required: true,
    disabled: true,
  },
  {
    key: 'billcode',
    name: lang('运单号'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverProvName',
    name: lang('目的地省份'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverCityName',
    name: lang('目的地城市'),
    required: true,
    disabled: true,
  },
  {
    key: 'packageInsideChargeWeight',
    name: lang('计费重量'),
    required: true,
    disabled: true,
  },
  {
    key: 'isCod',
    name: lang('是否COD'),
    required: true,
    disabled: true,
  },
  {
    key: 'codMoney',
    name: lang('COD贷款金额'),
    required: true,
    disabled: true,
  },
  {
    key: 'signTime',
    name: lang('签收时间'),
    required: true,
    disabled: true,
  },
  {
    key: 'isProblem',
    name: lang('是否问题件'),
    required: true,
    disabled: true,
  },
  {
    key: 'prblemReason',
    name: lang('问题件原因'),
    required: true,
    disabled: true,
  },
  {
    key: 'problemRegisterTime',
    name: lang('问题件登记时间'),
    required: true,
    disabled: true,
  },
  {
    key: 'problemDesc',
    name: lang('问题件描述'),
    required: true,
    disabled: true,
  },
  {
    key: 'isReturn',
    name: lang('是否退回件'),
    required: true,
    disabled: true,
  },
  {
    key: 'returnTime',
    name: lang('退回件登记时间'),
    required: true,
    disabled: true,
  },
  {
    key: 'returnInstitution',
    name: lang('退回机构'),
    required: true,
    disabled: true,
  },
  {
    key: 'signTimeLong',
    name: lang('总体签收时长'),
    required: true,
    disabled: true,
  },
]

// 出港详情字段
export const outPortDelOptions = [
  {
    key: 'queryTime',
    name: lang('揽收时间'),
    required: true,
    disabled: true,
  },
  {
    key: 'billcode',
    name: lang('运单号'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverProvName',
    name: lang('目的地省份'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverCityName',
    name: lang('目的地城市'),
    required: true,
    disabled: true,
  },
  {
    key: 'packageInsideChargeWeight',
    name: lang('计费重量'),
    required: true,
    disabled: true,
  },
  {
    key: 'isCod',
    name: lang('是否COD'),
    required: true,
    disabled: true,
  },
  {
    key: 'codMoney',
    name: lang('COD贷款金额'),
    required: true,
    disabled: true,
  },
  {
    key: 'signTime',
    name: lang('签收时间'),
    required: true,
    disabled: true,
  },
  {
    key: 'isProblem',
    name: lang('是否问题件'),
    required: true,
    disabled: true,
  },
  {
    key: 'prblemReason',
    name: lang('问题件原因'),
    required: true,
    disabled: true,
  },
  {
    key: 'problemRegisterTime',
    name: lang('问题件登记时间'),
    required: true,
    disabled: true,
  },
  {
    key: 'problemDesc',
    name: lang('问题件描述'),
    required: true,
    disabled: true,
  },
  {
    key: 'isReturn',
    name: lang('是否退回件'),
    required: true,
    disabled: true,
  },
  {
    key: 'returnTime',
    name: lang('退回件登记时间'),
    required: true,
    disabled: true,
  },
  {
    key: 'returnInstitution',
    name: lang('退回机构'),
    required: true,
    disabled: true,
  },
  {
    key: 'signTimeLong',
    name: lang('总体签收时长'),
    required: true,
    disabled: true,
  },
]

// 进港列表字段
export const enterOptions = [
  {
    key: 'queryTime',
    name: lang('派件日期'),
    required: true,
    disabled: true,
  },
  {
    key: 'deliverCount',
    name: lang('派件票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'signCount',
    name: lang('签收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'signTimeAvg',
    name: lang('签收平均时长'),
    required: true,
    disabled: true,
  },
  {
    key: 'unSignedCount',
    name: lang('待签收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'signRate',
    name: lang('签收率'),
    required: true,
    disabled: true,
  },
  {
    key: 'deliverCodCount',
    name: lang('COD揽收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'signCodCount',
    name: lang('COD签收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'unSignedCodCount',
    name: lang('COD待签收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'signRateCOD',
    name: lang('COD签收率'),
    required: true,
    disabled: true,
  },
  {
    key: 'deliverNoCodCount',
    name: lang('非COD揽收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'signNoCodCount',
    name: lang('非COD签收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'unSignedNonCodCount',
    name: lang('非COD待签收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'signedRateNonCod',
    name: lang('非COD签收率'),
    required: true,
    disabled: true,
  },
  {
    key: 'orderAccount',
    name: lang('下单账号'),
    required: true,
    disabled: true,
  },
]

// 出港列表字段
export const outOptions = [
  {
    key: 'queryTime',
    name: lang('揽收日期'),
    required: true,
    disabled: true,
  },
  {
    key: 'takingCount',
    name: lang('揽收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'signCount',
    name: lang('签收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'signTimeAvg',
    name: lang('签收平均时长'),
    required: true,
    disabled: true,
  },
  {
    key: 'unSignedCount',
    name: lang('待签收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'signRate',
    name: lang('签收率'),
    required: true,
    disabled: true,
  },
  {
    key: 'takingCodCount',
    name: lang('COD揽收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'signCodCount',
    name: lang('COD签收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'unSignedCodCount',
    name: lang('COD待签收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'signRateCOD',
    name: lang('COD签收率'),
    required: true,
    disabled: true,
  },
  {
    key: 'takingNoCodCount',
    name: lang('非COD揽收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'signNoCodCount',
    name: lang('非COD签收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'unSignedNonCodCount',
    name: lang('非COD待签收票数'),
    required: true,
    disabled: true,
  },
  {
    key: 'signedRateNonCod',
    name: lang('非COD签收率'),
    required: true,
    disabled: true,
  },
  {
    key: 'orderAccount',
    name: lang('下单账号'),
    required: true,
    disabled: true,
  },
]

// 第三方订单导出字段
export const customerOrderOptions = [
  {
    key: 'id',
    name: lang('订单编号'),
    required: true,
    disabled: true,
  },
  {
    key: 'waybillId',
    name: lang('运单编号'),
    required: true,
    disabled: true,
  },
  {
    key: 'orderStatusName',
    name: lang('状态'),
    required: true,
    disabled: true,
  },
  {
    key: 'orderSourceName',
    name: lang('订单来源'),
    required: true,
    disabled: true,
  },
  {
    key: 'printsNumber',
    name: lang('打印次数'),
    required: true,
    disabled: true,
  },
  {
    key: 'customerOrderId',
    name: lang('客户订单号'),
    required: true,
    disabled: true,
  },
  {
    key: 'customerWaybillNo',
    name: lang('第三方运单号'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverName',
    name: lang('收件人'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverMobilePhone',
    name: lang('收件电话'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverProvinceName',
    name: lang('收件省份'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverCityName',
    name: lang('收件城市'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverDetailedAddress',
    name: lang('收件地址'),
    required: true,
    disabled: true,
  },
  {
    key: 'receiverCompany',
    name: lang('收件人公司'),
  },
  {
    key: 'senderName',
    name: lang('寄件人'),
  },
  {
    key: 'senderMobilePhone',
    name: lang('寄件电话'),
  },
  {
    key: 'senderProvinceName',
    name: lang('寄件省份'),
  },
  {
    key: 'senderCityName',
    name: lang('寄件城市'),
  },
  {
    key: 'senderDetailedAddress',
    name: lang('寄件地址'),
  },
  {
    key: 'goodsTypeName',
    name: lang('物品类型'),
  },
  {
    key: 'goodsName',
    name: lang('物品名称'),
  },
  {
    key: 'packageTotalWeight',
    name: lang('物品重量'),
  },
  {
    key: 'declaredValue',
    name: lang('物品价值'),
  },
  {
    key: 'insuredValue',
    name: lang('赔偿上限服务费'),
  },
  {
    key: 'paymentModeName',
    name: lang('支付方式'),
  },
  {
    key: 'standardValue',
    name: lang('参考运费'),
  },
  {
    key: 'remarks',
    name: lang('备注'),
  },
//   {
//     key: 'orderAccount',
//     name: '下单账号',
//   },
]

// 国际件订单导出字段
export const orderOptionsInter = [
  {
    key: 'id',
    name: '订单编号',
    required: true,
    disabled: true,
  },
  {
    key: 'waybillId',
    name: '运单编号',
    required: true,
    disabled: true,
  },
  {
    key: 'orderStatusName',
    name: '状态',
    required: true,
    disabled: true,
  },
  {
    key: 'customerOrderId',
    name: '客户订单号',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverName',
    name: '收件人姓名',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverMobilePhone',
    name: '收件人手机号',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverTelphone',
    name: '收件人备用手机号码',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverCountryName',
    name: '收件人国家',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverProvinceName',
    name: '收件省份',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverCityName',
    name: '收件城市',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverStreet',
    name: '收件街道',
    required: true,
    disabled: true,
  },
  {
    key: 'receiverDetailedAddress',
    name: '收件详细地址',
    required: true,
    disabled: true,
  },
  {
    key: 'chineseName',
    name: '中文品名',
    required: true,
    disabled: true,
  },
  {
    key: 'englishName',
    name: '英文品名',
    required: true,
    disabled: true,
  },
  {
    key: 'goodsNumber',
    name: '件数',
    required: true,
    disabled: true,
  },
  {
    key: 'goodsValue',
    name: '申报价值',
    required: true,
    disabled: true,
  },
  {
    key: 'pricecurrency',
    name: '申报价值币别',
    required: true,
    disabled: true,
  },
  {
    key: 'goodsDesc',
    name: '物品描述',
    required: true,
    disabled: true,
  },
  {
    key: 'goodsUrl',
    name: 'URL',
    required: true,
    disabled: true,
  },
  {
    key: 'hsCode',
    name: '海关编码',
    required: true,
    disabled: true,
  },
  {
    name: '收件人区号',
    key: 'receiverPhoneAreacode'
  },
  {
    key: 'receiverIdNumber',
    name: '收件人证件号',
  },
  {
    key: 'internationalOrderStatus',
    name: '操作状态',
  },
  {
    key: 'serviceTypeName',
    name: '服务类型',
  },
  {
    key: 'senderCountryName',
    name: '寄件人国家',
  },
  {
    key: 'senderPhoneAreacode',
    name: '寄件人区号',
  },
  {
    key: 'senderName',
    name: '寄件人姓名',
  },
  {
    key: 'senderMobilePhone',
    name: '寄件人联系手机',
  },
  {
    key: 'senderProvinceName',
    name: '省份',
  },
  {
    key: 'senderCityName',
    name: '寄件城市',
  },
  {
    key: 'senderStreet',
    name: '寄件街道',
  },
  {
    key: 'senderDetailedAddress',
    name: '寄件详细地址',
  },
  {
    key: 'packageTotalWeight',
    name: '物品重量',
  },
  {
    key: 'packageLength',
    name: '长',
  },
  {
    key: 'packageWide',
    name: '宽',
  },
  {
    key: 'packageHigh',
    name: '高',
  },
  {
    key: 'printsNumber',
    name: '打印次数',
  },
  {
    key: 'codMoney',
    name: 'COD收款金额',
  },
  {
    key: 'remarks',
    name: '备注',
  },
  {
    key: 'codCurrencyTypeName',
    name: '代收货款币别',
  },
]

export const returnOrderList = [
  {
    key: 'id',
    name: lang('订单编号'),
  },
  {
    key: 'waybillId',
    name: lang('运单编号'),
  },
  {
    key: 'orderStatusName',
    name: lang('状态'), //  运单状态码(201:已收件，202：已发件，203：运输中，204：派送中，205：已签收，206：退件中，207：已退件)
  },
  {
    key: 'printsNumber',
    name: lang('打印次数'),
  },
  {
    key: 'originalWaybillId',
    name: lang('原始单号'),
  },
  {
    key: 'customerOrderId',
    name: lang('客户订单号'),
  },
  {
    key: 'senderName',
    name: lang('寄件人地址'),
  },
  {
    key: 'receiverName',
    name: lang('收件方'),
  },
  {
    key: 'needDispatch',
    name: lang('是否调度'),
  },
  {
    key: 'packageNumber',
    name: lang('件数'),
  },
  {
    key: 'goodsTypeName',
    name: lang('物品类型'),
  },
  {
    key: 'goodsName',
    name: lang('物品名称'),
  },
  {
    key: 'packageTotalWeight',
    name: lang('物品重量'),
  },
  {
    key: 'expressTypeName',
    name: lang('产品类型'),
  },
  {
    key: 'productSkuImageUrl',
    name: lang('商品图片'),
  },
  {
    key: 'productDescription',
    name: lang('商品描述'),
  },
  {
    key: 'paymentModeName',
    name: lang('结算方式'),
  },
  {
    key: 'paidModeName',
    name: lang('支付方式'),
  },
  {
    key: 'platformName',
    name: lang('平台'),
  },
  {
    key: 'customerAccount',
    name: lang('客户账号'),
  },
  {
    key: 'standardValue',
    name: lang('参考运费'),
  },
  {
    key: 'orderSourceName',
    name: lang('订单来源'),
  },
  {
    key: 'orderAccount',
    name: lang('下单账号'),
  },
  {
    key: 'printTime',
    name: lang('打印时间'),
  },
  {
    key: 'cancelReason',
    name: lang('取消原因'),
  },
]

export const orderOptionsInterHDL = [
  {
    key: 'customerOrderId',
    name: '客户订单编号'
  },
  {
    key: 'senderCountryName',
    name: '始发国'
  },
  {
    key: 'senderName',
    name: '寄件人姓名'
  },
  {
    key: 'senderCompany',
    name: '寄件人公司'
  },
  {
    key: 'senderAddress',
    name: '寄件人地址'
  },
  {
    key: 'senderCityName',
    name: '寄件城市名称'
  },
  {
    key: 'senderProvinceName',
    name: '寄件省份名称'
  },
  {
    key: 'senderEmail',
    name: '寄件人邮箱'
  },
  {
    key: 'senderMobilePhone',
    name: '寄件人手机号'
  },
  {
    key: 'receiverCountryName',
    name: '目的国'
  },
  {
    key: 'receiverName',
    name: '收件人姓名'
  },
  {
    key: 'receiverCompany',
    name: '收件人公司'
  },
  {
    key: 'receiverAddress',
    name: '收件地址'
  },
  {
    key: 'receiverPostalCode',
    name: '收件邮编'
  },
  {
    key: 'receiverCityName',
    name: '收件城市名称'
  },
  {
    key: 'receiverProvinceName',
    name: '收件省份名称'
  },
  {
    key: 'receiverEmail',
    name: '收件人邮箱'
  },
  {
    key: 'receiverMobilePhone',
    name: '收件人手机号'
  },
  {
    key: 'goodsValue',
    name: '包裹价值'
  },
  {
    key: 'pricecurrency',
    name: '申报币别'
  },
  {
    key: 'packageLength',
    name: '长'
  },
  {
    key: 'packageWide',
    name: '宽',
  },
  {
    key: 'packageHigh',
    name: '高',
  },
  {
    key: 'goodsTypeName',
    name: '物品类型名称',
  },
  {
    key: 'fileGoodsDesc',
    name: '文件物品描述',
  },
  {
    key: 'purposeshipment',
    name: '发货目的',
  },
  {
    key: 'goodsDesc',
    name: '物品描述',
  },
  {
    key: 'hsCode',
    name: '海关编码',
  },
  {
    key: 'packageNumber',
    name: '件数',
  },
  {
    key: 'itemUnit',
    name: '物品单位',
  },
  {
    key: 'goodsWeight',
    name: '单个物品重量',
  },
  {
    key: 'individualValue',
    name: '单个价值',
  }
]

